import { useContext, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import LogoFullWhiteImgSrc from '../../../assets/images/sendit-logo-full-white.svg';
import { SessionContext } from '../../../js/app/contexts/SessionContext';
import { useCanShowReferralButton } from '../../../js/app/hooks/providers';
import { useContextBar } from '../contexts/ContextBarContext';
import { getHomeUrl } from '../utils/navigation';
import { getInitials } from '../utils/utils';
import { Avatar } from './avatar';
import { Button } from './button';
import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownHeader,
  DropdownItem,
  DropdownMenu,
} from './dropdown';
import { ProviderReferralDialog } from './provider-referral-dialog';

export const ContextBar = () => {
  const { config } = useContextBar();
  const { user, logout } = useContext(SessionContext);
  const canShowReferralButton = useCanShowReferralButton();
  const navigate = useNavigate();
  const location = useLocation();
  const [isReferralDialogOpen, setIsReferralDialogOpen] = useState(false);
  const showButton = config?.buttonLabel && (config?.buttonUrl || config?.buttonOnClick);

  const handleButtonClick = () => {
    if (config?.buttonOnClick) {
      config.buttonOnClick();
    } else {
      if (config?.buttonUrl) {
        navigate(config.buttonUrl);
      }
    }
  };

  const handleLoginClick = () => {
    const currentPath = location.pathname + location.search;
    const nextParam = encodeURIComponent(currentPath);
    navigate(`/login?next=${nextParam}`);
  };

  const homeUrl = getHomeUrl(user, location.pathname);

  return (
    <div className="tw:flex tw:items-center tw:justify-between tw:pr-6 tw:py-1 tw:bg-brand-black-2">
      <div className="tw:flex tw:items-center tw:gap-4">
        {!user && (
          <Link to={homeUrl} className="tw:flex tw:items-center tw:ml-4">
            <img alt="Sendit logo" src={LogoFullWhiteImgSrc.toString()} className="tw:h-8" />
          </Link>
        )}
        {showButton && (
          <Button small color="brandgreen1" onClick={handleButtonClick}>
            {config.buttonLabel}
          </Button>
        )}
      </div>

      <div className="tw:flex tw:items-center tw:gap-3">
        {canShowReferralButton && (
          <Button
            color="brand-cta"
            className="tw:gap-0 tw:!text-sm tw:!py-1 tw:!font-medium"
            onClick={() => setIsReferralDialogOpen(true)}
          >
            <i className="fas fa-fw fa-dollar-sign" />
            <span className="">Refer & Earn</span>
          </Button>
        )}
        {user ? (
          <Dropdown>
            {/* TODO: figure out this style or use a different component */}
            <DropdownButton className="tw:flex tw:items-center tw:gap-2 tw:px-2 tw:py-1.5 tw:rounded-lg tw:!bg-transparent tw:!border-0 tw:!shadow-none tw:focus:!outline-none tw:before:!shadow-none tw:after:!shadow-none">
              <Avatar
                src={user?.profile_picture}
                initials={getInitials(`${user?.first_name} ${user?.last_name}`)}
                className="tw:size-8 tw:bg-brand-green-1 tw:text-white"
              />
              <i className="fas fa-chevron-down tw:text-zinc-300 tw:ml-1" />
            </DropdownButton>
            <DropdownMenu className="tw:min-w-64 tw:z-50" anchor="bottom end">
              <DropdownHeader>
                <div className="tw:text-xs tw:font-medium">
                  Signed in as: {`${user?.first_name} ${user?.last_name}`}
                </div>
                <div className="tw:text-xs tw:text-zinc-500">{user?.email}</div>
              </DropdownHeader>
              <DropdownDivider />
              <DropdownItem
                href="https://docs.google.com/forms/d/e/1FAIpQLSd2236EHQCrfhPqsbclegK7OCggNizrKXlIZu7xJjt-uJTydw/viewform?usp=header"
                target="_blank"
                rel="noopener noreferrer"
                className="tw:!no-underline tw:!text-base tw:!text-zinc-950"
              >
                <i className="fal fa-fw fa-lg fa-message-lines" />
                <span>Support</span>
              </DropdownItem>
              <DropdownItem onClick={() => logout?.()}>
                <i className="fal fa-fw fa-lg fa-arrow-right-from-bracket tw:mr-1" />
                <span>Sign out</span>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        ) : (
          <Button className="tw:!my-3" small color="brandgreen1" onClick={handleLoginClick}>
            Login
          </Button>
        )}
      </div>

      <ProviderReferralDialog
        open={isReferralDialogOpen}
        onClose={() => setIsReferralDialogOpen(false)}
      />
    </div>
  );
};
